import Button from "../../core/button/button";
import "./panelchange.scss";
import {useNavigate} from "react-router-dom";

interface IPanelChange {
    target: string
    title: string
}

const PanelChange = ({target, title}: IPanelChange) => {
    const navigate = useNavigate();
    return (
        <div className="Panel-Change">
            <img src={require("../../assets/images/icons/RotatedTrumpet.svg").default} alt=""
                 className="img-fluid Panel-Change-Image"/>
            <h6 className="Panel-Change-Text">برای کسب درآمد از تی‌جار</h6>
            <Button type={"primary"} action={() => {
                localStorage.setItem('userType', target);
                navigate(`../${target}/dashboard`, {replace: true});
            }} responsive={true}>
                <img src={require("../../assets/images/icons/ChangePanel.svg").default} alt="" className="img-fluid"/>
                &nbsp;
                {title}
            </Button>
        </div>
    )
}

export default PanelChange